import React from 'react';
import { Badge } from 'shards-react';
import { useTranslation } from 'react-i18next';

interface NotSavedAlertProps {
  saved: boolean;
}

const NotSavedAlert = ({ saved }: NotSavedAlertProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {!saved && (
        <div className="d-inline-flex align-items-center ml-4">
          <Badge className="d-inline" outline theme="danger">
            {t('controlVisible.dialog.request.error')}
          </Badge>
        </div>
      )}
    </>
  );
};

export default NotSavedAlert;
